import React from "react";
import Modal, { Header, Footer, Body } from "~/common/ModalReact";
import Button from "~/common/Buttons";

interface Props {
  isModalOpen: boolean;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const PlatinumPlusExclusiveModal = ({ isModalOpen, setIsModalOpen }: Props) => {
  return (
    <Modal
      isOpen={isModalOpen}
      onRequestClose={() => setIsModalOpen(false)}
      className="modal--md"
    >
      <Header closeModal={() => setIsModalOpen(false)}>
        <h3 className="flex m-0 ml-3 text-base md:text-xl">
          Temporarily Unavailable due to Global Shortage
        </h3>
      </Header>
      <Body>
        <p>
          Due to the high demand for this during the COVID-19 pandemic, this
          item is temporarily unavailable. WebstaurantStore is dedicated to
          finding solutions to the global supply chain shortages and we hope to
          make this item available again in the future.
        </p>
      </Body>
      <Footer>
        <Button
          type="button"
          color="light"
          onClick={() => setIsModalOpen(false)}
          className="mr-3"
        >
          Close
        </Button>
      </Footer>
    </Modal>
  );
};
export default PlatinumPlusExclusiveModal;
